import React from 'react';

export default function AccountMgt() {
  return <div>AccountMgt</div>;
}
